import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import { publicPath } from 'signals/publicPath';
import config from 'utils/config';

const competitions = config.competitions;

const Redirect = () => {
  const { competitionName } = useParams<{ competitionName?: string }>();
  const navigate = useNavigate();
  const PUBLIC_PATH = publicPath.value;

  useEffect(() => {
    const compName = competitionName || config.competitionsDefault.name;

    const competition = competitions.find((competition) => competition.name === compName);

    const seasonYear = competition?.seasonYear ?? new Date().getFullYear().toString();
    const link = `${PUBLIC_PATH}competitions/${compName}/${seasonYear}`;

    setTimeout(() => navigate(link, { replace: true }), 0);
  }, [PUBLIC_PATH, navigate, competitionName]);

  return null;
};

export default Redirect;
